import TextField from '@mui/material/TextField';
import type { ChangeEvent, FocusEvent } from 'react';

type GuardianFormFieldProps = {
  id: string;
  label: string;
  value: string;
  placeholder?: string;
  type?: 'text' | 'email';
  error?: string;
  showError: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
  inputMode?: 'text' | 'email' | 'numeric' | 'tel';
  autoComplete?: string;
};

export function GuardianFormField({
  id,
  label,
  value,
  placeholder,
  type = 'text',
  error,
  showError,
  onChange,
  onBlur,
  inputMode,
  autoComplete,
}: GuardianFormFieldProps): JSX.Element {
  const hasError = showError && Boolean(error);
  const errorId = `${id}-error`;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleBlur = (_event: FocusEvent<HTMLInputElement>) => {
    onBlur();
  };

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      value={value}
      placeholder={placeholder}
      type={type}
      fullWidth
      margin="normal"
      variant="outlined"
      error={hasError}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{
        inputMode,
        autoComplete,
        'aria-invalid': hasError,
        'aria-describedby': hasError ? errorId : undefined,
      }}
      helperText={hasError ? error : undefined}
      FormHelperTextProps={
        hasError ? { id: errorId, role: 'alert' } : undefined
      }
      data-testid={`guardian-field-${id}`}
    />
  );
}
